export default "__VITE_ASSET__Dj47DzOb__"